import { getAnalytics } from '@firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: 'AIzaSyABrcjXqLtf3cJyWIoheVpm7Unu9cAMIJM',
    authDomain: 'web-app-corporativa.firebaseapp.com',
    projectId: 'web-app-corporativa',
    storageBucket: 'web-app-corporativa.firebasestorage.app',
    messagingSenderId: '96615452975',
    appId: '1:96615452975:web:4af697ed9027ce213111da',
    measurementId: 'G-DR79E3DM4C',
};

export const messaging = function obtainMessaging() {
    const app = initializeApp(firebaseConfig);
    if (app) {
        try {
            const mess = getMessaging(app); 
            return mess;
        } catch (error) {   
        }
    }
}();

export const analytics = function obtainFirebaseAnalytics() {
    const app = initializeApp(firebaseConfig);
    if (app) {
        try {
            const analy = getAnalytics(app); 
            return analy;
        } catch (error) {   
        }
    }
}();